import { Box, EmptyView, Spacer } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useEffect, useState } from 'react'
import { ScrollView } from 'react-native'
import { Accordion } from '../../../comps/Accordion/Accordion'
import { ModBox } from '../../../comps/ModifiedBox/ModifiedBox'
import { useLazyApiData, useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { PaginationController } from '../../PaymentLinks/PaginationController/PaginationController'
import { Header } from './Header'
import { Info } from './Info'
import { SubscriptionInfoAlert } from './SubscriptionInfoAlert'

interface SubscriptionDetailProps {
  id: string
  onDismiss: () => void
}

const SubscriptionDetails: FC<SubscriptionDetailProps> = ({ onDismiss, id }: SubscriptionDetailProps) => {
  const { fetchSubscriptionDetails, getSubscriptionListDetails, fetchSubsTxnDetails, updateSelectedSubscription } =
    useStores((store: any) => ({
      fetchSubscriptionDetails: store.subscriptions.fetchSubscriptionDetailsTxnV3,
      getSubscriptionListDetails: store.subscriptions.getSubscriptionListDetails,
      fetchSubsTxnDetails: store.subscriptions.fetchSubsTxnDetailsV3,
      updateSelectedSubscription: store.subscriptions.updateSelectedSubscription,
    }))
  const [fetchDetails, fetchDetailsHandler] = useLazyApiData(fetchSubscriptionDetails)
  const [getSubsTxnDetails, getSubsTxnDetailsHandler] = useLazyApiData(fetchSubsTxnDetails)
  const [_index, setIndex] = useState(-1)

  useEffect(() => {
    if (id && id !== '0') {
      fetchDetails(id, 1)
    }
  }, [fetchDetails, id])

  const data = getSubscriptionListDetails(id)
  const { trxPagination, invoice } = data
  const navigation = useNavigation()

  const onRefund = (rrnid: string) => {
    updateSelectedSubscription(rrnid)
    navigation.navigate(Routes.SUBSCRIPTION_INITIATEREFUND)
    onDismiss()
  }

  const onPaymentHistory = (trxId: string, index: number) => {
    getSubsTxnDetails(id, trxId)
    setIndex(index)
  }

  const handleRetry = () => {
    if (id) {
      fetchDetails(id)
    }
  }

  const handlePagination = (selectedPage: number) => {
    fetchDetails(id, selectedPage)
  }

  const getEmptyMessage = () => {
    return data?.transactionsHistory?.length > 0 ? '' : 'No Transactions'
  }

  return (
    <ScrollView>
      <Box bg={'WHITE'} minHeight={'100vh'} width={600}>
        <Header
          id={id}
          invoice={invoice}
          status={data?.status}
          onPause={() => console.log('onpause')}
          onCancel={() => console.log('oncancel')}
          onDismiss={onDismiss}
        />
        <ModBox show={false} ph={24}>
          <Spacer size={24} direction={'vertical'} />
          <SubscriptionInfoAlert />
        </ModBox>
        <Info id={id} />
        <EmptyView
          isLoading={fetchDetailsHandler.state === 'pending'}
          onRetry={() => {
            if (handleRetry) {
              handleRetry()
            }
          }}
          loadingMessage="Loading"
          emptyMessage={getEmptyMessage()}
        />
        <ModBox show={data?.transactionsHistory?.length > 0}>
          <Box>
            <Accordion
              onRefund={onRefund}
              type={data?.type}
              data={data?.transactionsHistory}
              onPaymentHistory={onPaymentHistory}
              loading={{ isLoading: getSubsTxnDetailsHandler.state === 'pending', index: _index }}
            />
          </Box>
          <Box p={24} alignSelf={'flex-start'}>
            <PaginationController
              hide={false}
              currentPage={trxPagination?.number ?? 0}
              totalPages={trxPagination?.totalPages ?? 0}
              totalDataLength={trxPagination?.totalElements ?? 0}
              dataSetSize={trxPagination?.size ?? 0}
              onSelect={handlePagination}
              defaultPage={1}
            />
          </Box>
        </ModBox>
      </Box>
    </ScrollView>
  )
}

export { SubscriptionDetails }
